/**
 * @generated SignedSource<<875b74772d9b47890745f96a6c5e8bd0>>
 * @relayHash 55191360e4fb3f12c46476671cfc7458
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1b7c1346e13d2f2090997f08c338ae9a5daa96d017229d9177c7d9b3562f0707

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type uiPeriscopeQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  first?: number | null | undefined;
  isAutoDevJobsSuggestionEnabled: boolean;
  isCompassSuggestionsEnabled: boolean;
  isPullRequestSuggestionsEnabled: boolean;
  projectAris: ReadonlyArray<string>;
  sprintAutoDiscoveryLimit?: number | null | undefined;
};
export type uiPeriscopeQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"suggestions_periscope_SuggestionsPanel_fragmentRef">;
};
export type uiPeriscopeQuery = {
  response: uiPeriscopeQuery$data;
  variables: uiPeriscopeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAutoDevJobsSuggestionEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isCompassSuggestionsEnabled"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPullRequestSuggestionsEnabled"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectAris"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sprintAutoDiscoveryLimit"
},
v8 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v9 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v10 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v11 = {
  "kind": "Variable",
  "name": "projectAris",
  "variableName": "projectAris"
},
v12 = {
  "kind": "Variable",
  "name": "sprintAutoDiscoveryLimit",
  "variableName": "sprintAutoDiscoveryLimit"
},
v13 = [
  (v8/*: any*/),
  (v10/*: any*/)
],
v14 = {
  "kind": "ScalarField",
  "name": "id"
},
v15 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v16 = {
  "concreteType": "WorkSuggestionsOrderScore",
  "kind": "LinkedField",
  "name": "orderScore",
  "plural": false,
  "selections": [
    {
      "concreteType": "WorkSuggestionsOrderScores",
      "kind": "LinkedField",
      "name": "byTaskType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "major"
        },
        {
          "kind": "ScalarField",
          "name": "minor"
        }
      ]
    }
  ]
},
v17 = {
  "kind": "ScalarField",
  "name": "url"
},
v18 = {
  "kind": "ScalarField",
  "name": "title"
},
v19 = {
  "kind": "ScalarField",
  "name": "issueKey"
},
v20 = {
  "kind": "ScalarField",
  "name": "lastUpdated"
},
v21 = {
  "kind": "ScalarField",
  "name": "destinationBranchName"
},
v22 = {
  "kind": "ScalarField",
  "name": "providerName"
},
v23 = {
  "kind": "ScalarField",
  "name": "providerIconUrl"
},
v24 = {
  "kind": "ScalarField",
  "name": "approvalsCount"
},
v25 = {
  "kind": "ScalarField",
  "name": "commentCount"
},
v26 = {
  "kind": "ScalarField",
  "name": "repositoryName"
},
v27 = {
  "kind": "ScalarField",
  "name": "issueIconUrl"
},
v28 = {
  "kind": "ScalarField",
  "name": "name"
},
v29 = {
  "kind": "ScalarField",
  "name": "iconUrl"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "uiPeriscopeQuery",
    "selections": [
      {
        "args": [
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "kind": "Variable",
            "name": "isAutoDevJobsSuggestionEnabled",
            "variableName": "isAutoDevJobsSuggestionEnabled"
          },
          {
            "kind": "Variable",
            "name": "isCompassSuggestionsEnabled",
            "variableName": "isCompassSuggestionsEnabled"
          },
          {
            "kind": "Variable",
            "name": "isPullRequestSuggestionsEnabled",
            "variableName": "isPullRequestSuggestionsEnabled"
          },
          (v11/*: any*/),
          (v12/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "suggestions_periscope_SuggestionsPanel_fragmentRef"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v7/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "uiPeriscopeQuery",
    "selections": [
      {
        "concreteType": "WorkSuggestions",
        "kind": "LinkedField",
        "name": "workSuggestions",
        "plural": false,
        "selections": [
          {
            "args": [
              (v9/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "concreteType": "WorkSuggestionsByProjectsResponse",
            "kind": "LinkedField",
            "name": "suggestionsByProjects",
            "plural": false,
            "selections": [
              {
                "args": (v13/*: any*/),
                "concreteType": "WorkSuggestionsConnection",
                "kind": "LinkedField",
                "name": "commonSuggestions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "WorkSuggestionsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isWorkSuggestionsCommon"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/)
                            ],
                            "type": "WorkSuggestionsBuildTask"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v17/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "environmentType"
                              },
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/)
                            ],
                            "type": "WorkSuggestionsDeploymentTask"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v18/*: any*/),
                              (v17/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v25/*: any*/),
                              (v26/*: any*/)
                            ],
                            "type": "WorkSuggestionsPullRequestReviewTask"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v18/*: any*/),
                              (v17/*: any*/),
                              (v25/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v26/*: any*/),
                              {
                                "concreteType": "WorkSuggestionsUserDetail",
                                "kind": "LinkedField",
                                "name": "reviewers",
                                "plural": true,
                                "selections": [
                                  (v15/*: any*/),
                                  (v14/*: any*/)
                                ]
                              }
                            ],
                            "type": "WorkSuggestionsPullRequestNeedsWorkTask"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "securityContainerName"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "status"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "introducedDate"
                              }
                            ],
                            "type": "WorkSuggestionsCriticalVulnerabilityTask"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v27/*: any*/),
                              {
                                "concreteType": "WorkSuggestionsBlockedIssue",
                                "kind": "LinkedField",
                                "name": "blockedIssues",
                                "plural": true,
                                "selections": [
                                  (v19/*: any*/),
                                  (v18/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "storyPoints"
                                  },
                                  (v27/*: any*/),
                                  {
                                    "concreteType": "WorkSuggestionsJiraAssignee",
                                    "kind": "LinkedField",
                                    "name": "assignee",
                                    "plural": false,
                                    "selections": [
                                      (v28/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "pictureUrl"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "WorkSuggestionsJiraPriority",
                                    "kind": "LinkedField",
                                    "name": "priority",
                                    "plural": false,
                                    "selections": [
                                      (v29/*: any*/),
                                      (v28/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "type": "WorkSuggestionsBlockingIssueTask"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v13/*: any*/),
                "handle": "connection",
                "key": "periscope__commonSuggestions",
                "kind": "LinkedHandle",
                "name": "commonSuggestions"
              },
              {
                "concreteType": "WorkSuggestionsOrder",
                "kind": "LinkedField",
                "name": "sortOrder",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "defaultOrder"
                  }
                ]
              },
              {
                "condition": "isAutoDevJobsSuggestionEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "autoDevJobsSuggestions",
                    "plural": true,
                    "selections": [
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isWorkSuggestionsAutoDevJobTask"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "WorkSuggestionsAutoDevJobJiraIssue",
                            "kind": "LinkedField",
                            "name": "issue",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "key"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "summary"
                              },
                              (v29/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "webUrl"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "repoUrl"
                          }
                        ],
                        "type": "WorkSuggestionsAutoDevJobsPlanSuccessTask"
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "isPullRequestSuggestionsEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "pullRequestSuggestions",
                    "plural": true,
                    "selections": [
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isWorkSuggestionsPeriscopeTask"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v18/*: any*/),
                          (v17/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v21/*: any*/),
                          {
                            "concreteType": "WorkSuggestionsPRComment",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "avatar"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "text"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "commenterName"
                              },
                              (v17/*: any*/)
                            ]
                          }
                        ],
                        "type": "WorkSuggestionsPRCommentsTask"
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "isCompassSuggestionsEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "compassSuggestions",
                    "plural": true,
                    "selections": [
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isWorkSuggestionsCompassTask"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v18/*: any*/),
                          (v17/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "componentName"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "description"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "senderComponentName"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "targetDate"
                          }
                        ],
                        "type": "WorkSuggestionsCompassAnnouncementTask"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "1b7c1346e13d2f2090997f08c338ae9a5daa96d017229d9177c7d9b3562f0707",
    "metadata": {},
    "name": "uiPeriscopeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "aae7901c6263945527f51cb60a49484c";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
